<div class="p-6">
  <!-- Toast notifications -->
  <p-toast position="top-right"></p-toast>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>

  <!-- Header Section -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h1 class="text-heading-xl mb-2">
        {{ 'successStories.title' | translate }}
      </h1>
      <p class="text-body-md text-secondary">
        {{ 'successStories.subtitle' | translate }}
      </p>
    </div>
    @if (loading()) {
    <p-skeleton width="8rem" height="2.5rem" class="flex-shrink-0"></p-skeleton>
    } @else {
    <p-button [label]="'successStories.addStory' | translate" icon="pi pi-plus" [disabled]="loading()"
      (onClick)="openAddSuccessStoryDialog()" class="flex-shrink-0">
    </p-button>
    }
  </div>

  <!-- Loading State -->
  @if (loading()) {
  <app-loading-spinner size="4rem" message="Loading success stories..." containerClass="py-16">
  </app-loading-spinner>
  } @else if (successStories.length === 0) {
  <!-- Empty State -->
  <div class="text-center py-12">
    <div class="text-muted mb-4">
      <i class="pi pi-bookmark text-6xl"></i>
    </div>
    <h3 class="text-heading-md mb-2">
      {{ 'successStories.noStories' | translate }}
    </h3>
    <p class="text-body-md text-secondary mb-6">
      {{ 'successStories.noStoriesDescription' | translate }}
    </p>
    @if (loading()) {
    <p-skeleton width="10rem" height="2.5rem"></p-skeleton>
    } @else {
    <p-button [label]="'successStories.addFirstStory' | translate" icon="pi pi-plus"
      (onClick)="openAddSuccessStoryDialog()">
    </p-button>
    }
  </div>
  } @else {
  <!-- Stories Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    @for (story of successStories; track story.id; let i = $index) {
    <app-success-story-item [story]="story" [index]="i" [coverImageUrl]="getCoverImageUrl(story.coverImage)"
      (edit)="onEditStory($event)" (remove)="onRemoveStory($event)">
    </app-success-story-item>
    }
  </div>
  }
</div>
